/** @jsxImportSource @emotion/react */

'use client';
import { Dialog } from '@mui/material';

import Spinner from '../Spinner';
import * as styles from './styles';

export default function SpinnerModal() {
  return (
    <Dialog
      transitionDuration={0}
      open
      css={styles.modal}
    >
      <Spinner />
    </Dialog>
  );
}
